import { Checkbox, Label } from "@devhop/ui";
import { formatDateTimeLocal } from "@/shared/lib/date-time-performance";
import type { EventShowDTO } from "../../domain/contracts";

type AssignmentShowPickerProps = {
  eventShows: EventShowDTO[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  singleSelect?: boolean;
  disabled?: boolean;
};

export function AssignmentShowPicker({
  eventShows,
  selectedIds,
  onChange,
  singleSelect = false,
  disabled = false,
}: AssignmentShowPickerProps) {
  const sorted = [...eventShows].sort(
    (a, b) =>
      new Date(a.showDate).getTime() - new Date(b.showDate).getTime() ||
      a.sortOrder - b.sortOrder,
  );

  const toggle = (showId: string, checked: boolean) => {
    if (singleSelect) {
      onChange(checked ? [showId] : []);
      return;
    }
    if (checked) {
      onChange([...new Set([...selectedIds, showId])]);
      return;
    }
    onChange(selectedIds.filter((id) => id !== showId));
  };

  return (
    <div className="space-y-2">
      <p className="font-medium text-sm">ເລືອກໂຊທີ່ນັກສະແດງຄົນນີ້ເຂົ້າຮ່ວມ</p>
      <p className="text-muted-foreground text-xs">
        {singleSelect
          ? "ຄົນຕັດແຕ່ງເພງເລືອກໄດ້ພຽງ 1 ໂຊ"
          : "ບໍ່ເລືອກ = ບໍ່ຄິດຄ່າໂຊນັ້ນ"}
      </p>
      <ul className="space-y-2 rounded-md border bg-muted/10 p-3">
        {sorted.map((show, index) => {
          const checked = selectedIds.includes(show.id);
          const inputId = `assignment-show-${show.id}`;
          return (
            <li key={show.id}>
              <Label
                htmlFor={inputId}
                className={`flex cursor-pointer items-start gap-3 rounded-md border px-3 py-2 transition-colors ${
                  checked
                    ? "border-primary bg-primary/5"
                    : "border-transparent bg-background hover:bg-muted/30"
                } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
              >
                <Checkbox
                  id={inputId}
                  checked={checked}
                  disabled={disabled}
                  onCheckedChange={(value) =>
                    toggle(show.id, value === true)
                  }
                  className="mt-0.5"
                />
                <span className="min-w-0 flex-1">
                  <span className="block font-medium text-sm">
                    ໂຊ {index + 1}
                    {show.sortOrder > 0 ? ` · #${show.sortOrder + 1}` : ""}
                  </span>
                  <span className="block text-muted-foreground text-xs">
                    {formatDateTimeLocal(show.showDate)}
                    {show.notes ? ` · ${show.notes}` : ""}
                  </span>
                </span>
              </Label>
            </li>
          );
        })}
      </ul>
      <p className="text-muted-foreground text-xs">
        ເລືອກ {selectedIds.length}/{sorted.length} ໂຊ
      </p>
    </div>
  );
}
